module.exports = __webpack_public_path__ + "static/media/arva.30edd8d0.mp3";